import 'core-js';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider as StateProvider } from 'react-redux';
import { ApolloProvider as ApolloClientProvider } from '@apollo/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import ApiClientSuperagent from 'ps-components/lib/ApiClientSuperagent';
import configureStore from './store';
import client from './apollo';
import App from './containers/App';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';

//React18 upgrade changes
const container = document.getElementById('root');
const root = createRoot(container);

const queryClient = new QueryClient();
const apiClient = new ApiClientSuperagent(); 

const store = configureStore({}, apiClient);
const { config } = store.getState();

root.render(
  <React.StrictMode>
  <ApolloClientProvider client={client}>
  <StateProvider store={store}>
    <QueryClientProvider client={queryClient}>
      <MantineProvider>
          <Notifications position='top-right' />
          <Router basename={`${config.mount}/view/o/${config.orgCode}/mp`}>
            <App />
          </Router>
      </MantineProvider>
    </QueryClientProvider>
  </StateProvider>
</ApolloClientProvider>
</React.StrictMode>
); 

// Accept hot updates for './reducers'
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers').default;
    store.replaceReducer(nextRootReducer);
  });
} 
